<template>
    <div class="layout-with-navigation">
        <div class="layout-with-navigation__sidebar" :style="styleSidebar">
            <slot name="navigation"></slot>
        </div>
        <div class="layout-with-navigation__content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        sidebarWidth: {
            type: String,
            default: '216px',
        },
    },
    computed: {
        styleSidebar() {
            return {
                flex: `0 0 ${this.sidebarWidth}`,
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.layout-with-navigation {
    display: flex;
    gap: var(--spacing-4);
    max-height: calc(100% - 56px);

    &__content {
        flex: 1;
        min-width: 0;
    }
}
</style>
